import { useEffect } from 'react';

import { expVal } from '@confluence/feature-experiments';

import { useNewContentHistoryActions } from './useNewContentHistoryState';

// Hooks for cleanups & setting state for new content history to determine if content history was transitioned from editor.
// The new content history is only available to open via the editor for live pages at the moment & classic pages have the existing experience.
// We need this for this case where we don't do a full page re-direct and only update the URL.
export const useNewContentHistoryEditorTransition = (isLivePage: boolean, contentId: string) => {
	const { setWasTransitionedFromEditor, hideNewContentHistory } = useNewContentHistoryActions();

	useEffect(() => {
		if (isLivePage && expVal('confluence_content_history_updates', 'isEnabled', false)) {
			setWasTransitionedFromEditor(true);
		}
	}, [isLivePage, setWasTransitionedFromEditor, contentId]);

	useEffect(() => {
		// Reset states on editor unmount - not checking expVal here since it doesn't really matter and we just resetting to default
		return () => {
			hideNewContentHistory();
			setWasTransitionedFromEditor(false);
		};
	}, [setWasTransitionedFromEditor, hideNewContentHistory, contentId]);
};
